import {
  AbstractControl,
  FormArray,
  FormControl,
  ɵFormArrayValue,
} from '@angular/forms';

export class PatchableFormArray<
  T extends AbstractControl<any, any>,
> extends FormArray<T> {
  override patchValue(
    values: ɵFormArrayValue<T>,
    options?: { onlySelf?: boolean; emitEvent?: boolean },
  ) {
    this.adjustControls(values);
    super.patchValue(values, options);
  }

  private adjustControls(values: ɵFormArrayValue<T>) {
    if (!(values.length === this.length)) {
      this.clear();
      values.forEach((value) =>
        this.push(new FormControl(value ?? '', {}) as unknown as T),
      );
    }
  }
}
